$(document).ready(function() {
  removeMenuImage();
});

$(window).on('load', function(){
  menuFullHeight();
});

$(window).resize( function(){
  menuFullHeight();
  removeMenuImage();
});

function menuFullHeight(){
  $('.content-viewport').height( $(window).innerHeight());
  $('.tovaglia').height( $('main.content').width() );
  $('.tovaglia').width( $('main.content').width() );

  $('.oggetti').height( $('main.content').width() );
  $('.oggetti').width( $('main.content').width() );

}

function removeMenuImage(){
  if( $(window).width() < 960 ) {
    $('main.content > div img').each(function(index, el) {
      $(this).attr('data-src', $(this).attr('src'));
      $(this).removeAttr('src');
    });
  }else{
    $('main.content > div img').each(function(index, el) {
      $(this).attr('src', $(this).attr('data-src'));
      $(this).removeAttr('data-src');
    });
  }
}


$(window).on( 'load', function() {

  if( !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) || $(window).width() >= 960 ) {
    Draggable.create('.oggetti',{
      throwProps:true,
      bounds: {
        minX: $('.content-viewport').width() - $('main.content').width() ,
        minY: $('.content-viewport').height() - $('main.content').height(),
        maxX:0,
        maxY:0
      },

      rotation:0.01,
      force3D:true,

      onDrag:Update,
      onThrowUpdate:Update
    });

    TweenLite.set('.oggetti',{x: -($('main.content').width()/2)+ $('.content-viewport').width()/2 ,y:-($('main.content').height()/2)+ $('.content-viewport').height()/2});
    TweenLite.set('.pallini',{x: (-($('main.content').width()/2)+ $('.content-viewport').width()/2)*0.9 ,y:(-($('main.content').height()/2)+ $('.content-viewport').height()/2)*0.9});
    TweenLite.set('.tovaglia',{x: (-($('main.content').width()/2)+ $('.content-viewport').width()/2)*0.9 ,y:(-($('main.content').height()/2)+ $('.content-viewport').height()/2)*0.9});

    function Update(){
      var X = this.x , Y = this.y;
      TweenLite.set('.pallini',{x:X*0.9,y:Y*0.9});
      TweenLite.set('.tovaglia',{x:X*0.9,y:Y*0.9});
    };

    $('.button-menu__food').on('click', function() {
      var ele = $('.oggetti div:first-child'),
        oggettiX = - ele.width() + ( ( $(window).width() - $('.menu-food').width() ) / 2 ) ,
        oggettiY = - ele.height()*0.28;
      goToMenu(oggettiX, oggettiY);
    });

    $('.button-menu__wine').on('click', function() {
      var ele = $('.oggetti div:first-child').width() + $('.oggetti div:nth-child(2)').width() + $('.oggetti div:nth-child(3)').width(),
        oggettiX = - ele + ( ( $(window).width() - $('.menu-food').width() ) / 2 ) ,
        oggettiY = - $('.oggetti div:first-child').height()*0.35;
      goToMenu(oggettiX, oggettiY);
    });

    $('.button-menu__giorno').on('click', function() {
      var ele = $('.oggetti div:first-child').width() + $('.oggetti div:nth-child(2)').width() + $('.oggetti div:nth-child(3)').width() + $('.oggetti div:nth-child(4)').width(),
        oggettiX = - ele + ( ( $(window).width() - $('.menu-day').width() ) / 2 ) ,
        oggettiY = - $('.oggetti div:first-child').height()*0.25;
      goToMenu(oggettiX, oggettiY);
    });
  }

  function goToMenu(oggettiX, oggettiY){
    TweenLite.to(
      $('.oggetti'),1,{
        x: oggettiX,
        y: oggettiY,
        rotation:0.01,
        ease:Linear.easeNone,
        force3D:true,
        onStart:goToMenuTovagliaPallini(oggettiX,oggettiY)
      }
    );
  }

  function goToMenuTovagliaPallini(oggettiX, oggettiY){
    oggettiX = oggettiX * .9;
    oggettiY = oggettiY * .9;
    TweenLite.to(
      $('.tovaglia, .pallini'),1,{
      x: oggettiX,
      y: oggettiY,
      rotation:0.01,
      ease:Linear.easeNone,
      force3D:true
      }
    );
  }

});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/menu.js
 ** module id = 131
 ** module chunks = 0
 **/